import styled from 'styled-components'

import { BORDER_RADIUS } from '~/common/globalStyles'

const Card = styled.div(
  ({ theme }) => `
  border-radius: ${BORDER_RADIUS}px;
  background-color: ${theme.palette?.background?.paper || 'white'};
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08),
    0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`,
)

/** @component */
export default Card
